/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Val2_TitleInputs */

const en_st_val2_title = /** @type {(inputs: St_Val2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A client progress page backed by evidence`)
};

const id_st_val2_title = /** @type {(inputs: St_Val2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman progres klien dengan bukti`)
};

/**
* | output |
* | --- |
* | "A client progress page backed by evidence" |
*
* @param {St_Val2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_val2_title = /** @type {((inputs?: St_Val2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Val2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_val2_title(inputs)
	return en_st_val2_title(inputs)
});